(function () {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.shell.WizardRoadmapStep
	 * @module mx.shell
	 *
	 * @description
	 * Type that contains information about wizard's roadmap step.
	 * A constructor accepts `options` parameter that may contain fields to extend corresponding properties.
	 * ```javascript
	 var roadmapStep = new RoadmapStep({
	 	title: 'Step 1',
	 	description: 'On this step we perform actions related to step 1.',
		orderNum: 1
	 });
	 * ```
	 *
	 * @property {string} id - Gets or sets wizard step identifier this page is related to.<br>Defaults to `base`
	 * @property {string} title - Gets or sets step's title
	 * @property {string} description - Gets or sets descriptive information about step
	 * @property {boolean} passed - Gets or sets a flag indicating if wizard step is passed already.<br>Defaults to `false`
	 * @property {boolean} isCurrent - Gets or sets a flag indicating that wizard step is current wizard step.<br>Defaults to `false`
	 * @property {int} orderNum - Gets or sets step's order number to be displayed near step.<br>Defaults to `1`
	 */
	angular.module('mx.shell').factory('mx.shell.WizardRoadmapStep', [
		function wizardRoadmapStepFactory() {
			return WizardRoadmapStep;
		},
	]);

	function WizardRoadmapStep(options) {
		var that = this;

		Object.defineProperty(that, 'id', {
			writable: true,
			value: 'base',
		});
		Object.defineProperty(that, 'title', { writable: true });
		Object.defineProperty(that, 'key', {
			writable: true,
			value: 'Undefined',
		});
		Object.defineProperty(that, 'description', { writable: true });
		Object.defineProperty(that, 'passed', {
			writable: true,
			value: false,
		});
		Object.defineProperty(that, 'orderNum', {
			writable: true,
			value: 1,
		});
		Object.defineProperty(that, 'isCurrent', {
			writable: true,
			value: false,
		});

		Object.defineProperty(that, 'toBeSkipped', {
			writable: true,
			value: false,
		});

		that = angular.extend(that, options);
	}
})();
